import { render, staticRenderFns } from "./DFRApprovalPage.vue?vue&type=template&id=7f2fa93e"
import script from "./DFRApprovalPage.vue?vue&type=script&lang=js"
export * from "./DFRApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./DFRApprovalPage.vue?vue&type=style&index=0&id=7f2fa93e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports